"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    return (extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) b.hasOwnProperty(p) && (d[p] = b[p]);
    })(d, b);
  };
  return function (d, b) {
    function __() {
      this.constructor = d;
    }
    extendStatics(d, b), d.prototype = null === b ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var React = require("react");
function isMouseMoveEvent(e) {
  return "clientY" in e;
}
exports.isMouseMoveEvent = isMouseMoveEvent;
var Carousel = function (_super) {
  function Carousel() {
    return null !== _super && _super.apply(this, arguments) || this;
  }
  return __extends(Carousel, _super), Carousel;
}(React.Component);
exports.default = Carousel;